import Api from '@/services/Api'
import axios from 'axios'

const token = localStorage.getItem('access_token');

export default {
  changePage(page) {
    return Api().get('/pratica?page=' + page + '&limit=10');
  },

  changePageUtente(page, id_utente) {
    return Api().get('pratica?page=' + page + '&limit=10&CREATA_DA=' + id_utente,);
  },

  caricaPratica(id) {
    return Api().get('/pratica/' + id);
  },

  createPratica(dati) {
    return Api().post('/pratica', dati);
  },

  filterByAvanzamento(statoAvanzamento) {
    return Api().get('/pratica?filter=true&AVANZAMENTO='+statoAvanzamento)
  },

  get10Pratiche() {
    return Api().get('/pratica?page=1&limit=10');
  },

  get10PraticheUtente(id_utente) {
    return Api().get('pratica?filter=true&page=1&limit=10&CREATA_DA=' + id_utente);
  },

  getPratiche() {
    return Api().get('/pratica');
  },

  getPraticheUtente(id_utente) {
    return Api().get('/pratica?filter=true&CREATA_DA=' + id_utente);
  },

  
  // headers: {
  //       'Content-type': 'multipart/form-data',
  //       'Authorization': `Bearer ${token}`
  //     }

  uploadFile(id, data) {
    // return Api.post('/pratica/' + id + '/meta', data);
    return axios.create({
      baseURL: 'https://sviluppoallergeni.confcom.it',
      withCredentials: true,
      headers: {
        'Content-type': 'multipart/form-data',
        'Authorization': `Bearer ${token}`
      }
    }).post('/pratica/' + id + '/meta', data);
  },


  updatePratica(id, dati) {
    return Api().put('/pratica/' + id, dati);
  },

}
